// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"330375f8","146":"0a277dad","149":"aeeaa87b","378":"6770a8c8","453":"e1ea47d0","526":"79a6df95","562":"719319e4","622":"9e808098","645":"4542bc62"}[chunkId] + ".chunk.js";
};